import { ref } from 'vue';

/**
 * Brand accent color switching.
 * Default "turquoise" is defined in :root (no attribute).
 * Presets pink / indigo / violet / green / amber live under
 * [data-accent="X"] in tokens.css.
 */

export const ACCENT_PRESETS = [
  { id: 'turquoise', label: 'Turquoise', swatch: 'oklch(50% 0.110 200)' },
  { id: 'pink',      label: 'Pink',      swatch: 'oklch(58% 0.175 355)' },
  { id: 'indigo',    label: 'Indigo',    swatch: 'oklch(46% 0.140 255)' },
  { id: 'violet',    label: 'Violet',    swatch: 'oklch(50% 0.180 295)' },
  { id: 'green',     label: 'Green',     swatch: 'oklch(52% 0.135 150)' },
  { id: 'amber',     label: 'Amber',     swatch: 'oklch(62% 0.160 70)'  },
];

const STORAGE_KEY = 'quickprice-accent';
const DEFAULT_ACCENT = 'turquoise';
const VALID_IDS = new Set(ACCENT_PRESETS.map(p => p.id));

const currentAccent = ref(DEFAULT_ACCENT);

function applyAccent(id) {
  const html = document.documentElement;
  if (id === DEFAULT_ACCENT) {
    html.removeAttribute('data-accent');
  } else {
    html.setAttribute('data-accent', id);
  }
}

export function initAccent() {
  let saved = null;
  try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) { /* private mode */ }
  const id = VALID_IDS.has(saved) ? saved : DEFAULT_ACCENT;
  currentAccent.value = id;
  applyAccent(id);
}

export function useAccent() {
  const setAccent = (id) => {
    if (!VALID_IDS.has(id)) return;
    currentAccent.value = id;
    applyAccent(id);
    try { localStorage.setItem(STORAGE_KEY, id); } catch (e) { /* ignore */ }
  };

  return {
    currentAccent,
    setAccent,
    presets: ACCENT_PRESETS,
  };
}
